module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_013.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_013.png
// module id = 2329
// module chunks = 5